import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContactStateDescriptionItem } from '../../modules/contact-list/contact-list.models';
import { ContactListService } from '../../modules/contact-list/contact-list.service';

@Component({
    selector: 'cv-cxone-contact-state-descriptions-selector',
    templateUrl: './cxone-contact-state-descriptions-selector.component.html',
    styleUrls: ['./cxone-contact-state-descriptions-selector.component.scss']
})
export class CxoneContactStateDescriptionsSelectorComponent implements OnInit {
    get selectedIds(): number[] { return this._selectedIds; }
    @Input() set selectedIds(val: number[]) {
        this._selectedIds = val;

        if (!this.isSelectorOpen && this._selectedIds.length === 0 && this.descriptions.length) {
            this._selectedIds = this.descriptions.map(d => d.ContactStateID);
        }
    }

    @Output() selectedIdsChange = new EventEmitter<number[]>();

    isLoading = true;
    isSelectorOpen = false;
    descriptions: ContactStateDescriptionItem[] = [];

    private _selectedIds: number[] = [];

    constructor(
        private service: ContactListService,
    ) {

    }

    async ngOnInit() {
        try {
            this.isLoading = true;
            this.descriptions = await this.service.loadDescriptions();

            if (this.selectedIds.length === 0) {
                this.selectedIds = this.descriptions.map(d => d.ContactStateID);
            }
        } finally {
            this.isLoading = false;
        }
    }

    onSelectorClose() {
        this.isSelectorOpen = false;
        this.selectedIds = this._selectedIds;
    }
}
